import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  situation: 'Dudas',
  without: 'Más dudas',
  with: 'Más claridad'
}, {
  situation: 'Precisión',
  without: 'Más improvisación',
  with: 'Más precisión'
}, {
  situation: 'Errores',
  without: 'Más errores',
  with: 'Más seguridad'
}, {
  situation: 'Criterio',
  without: 'Más inseguridad',
  with: 'Más criterio profesional'
}, {
  situation: 'Resultados',
  without: 'Más tiempo perdido',
  with: 'Más resultados consistentes'
}];
export function ComparisonTable() {
  return <section className="bg-white py-16 px-5" data-id="element-58">
      <div className="max-w-xl mx-auto" data-id="element-59">
        <h2 className="text-2xl md:text-3xl font-black text-center text-slate-900 mb-12" data-id="element-60">
          La diferencia es clara
        </h2>

        <div className="bg-slate-50 border border-slate-100 rounded-3xl overflow-hidden mb-12 shadow-sm" data-id="element-61">
          <div className="grid grid-cols-3 text-center text-[10px] font-black uppercase tracking-widest border-b border-slate-100" data-id="element-62">
            <div className="p-4 text-slate-400 bg-white" data-id="element-63">Situación</div>
            <div className="p-4 text-red-500 bg-red-50/50" data-id="element-64">
              Sin sistema completo
            </div>
            <div className="p-4 bg-[#C8A96B]/10 text-[#C8A96B]" data-id="element-65">
              Con Colorimetría Pro™
            </div>
          </div>
          {rows.map((row, idx) => <div key={idx} className="grid grid-cols-3 text-center border-b border-slate-100 last:border-b-0" data-id="element-66">
              <div className="p-5 text-xs font-bold text-slate-500 flex items-center justify-center bg-white" data-id="element-67">
                {row.situation}
              </div>
              <div className="p-5 bg-red-50/20 flex flex-col items-center justify-center gap-2" data-id="element-68">
                <X size={20} className="text-red-400" data-id="element-69" />
                <span className="text-[11px] text-slate-400 font-bold italic" data-id="element-70">
                  {row.without}
                </span>
              </div>
              <div className="p-5 bg-brand-gold/5 flex flex-col items-center justify-center gap-2" data-id="element-71">
                <Check size={20} className="text-[#C8A96B]" data-id="element-72" />
                <span className="text-[11px] text-slate-900 font-black" data-id="element-73">
                  {row.with}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}